require("!!D:\\lmx_repository\\logimax_wholesale\\khazanchi\\node_modules\\script-loader\\addScript.js")(require("!!D:\\lmx_repository\\logimax_wholesale\\khazanchi\\node_modules\\raw-loader\\index.js!D:\\lmx_repository\\logimax_wholesale\\khazanchi\\node_modules\\jquery-slimscroll\\jquery.slimscroll.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/jquery-slimscroll/jquery.slimscroll.js
// module id = 452
// module chunks = 19